import { Component, Input } from '@angular/core';
import { SuiteShellService } from '@services/suite-shell.service';
import { etiquetaInterruptor } from '@services/suite-shell.logic';

@Component({
  selector: 'app-suite-switch',
  templateUrl: './suite-switch.component.html',
  styleUrls: ['./suite-switch.component.scss'],
  standalone: false,
})
export class SuiteSwitchComponent {
  @Input() ubicacion: 'intro' | 'header' = 'header';

  constructor(public shell: SuiteShellService) {}

  get etiqueta(): string {
    return etiquetaInterruptor(this.shell.cara);
  }

  alternar(): void {
    const destino = this.shell.cara === 'suite' ? 'classic' : 'suite';
    this.shell.elegir(destino);
  }
}
